import { render, staticRenderFns } from "./MedicationTable.vue?vue&type=template&id=401573d8&scoped=true"
import script from "./MedicationTable.vue?vue&type=script&lang=js"
export * from "./MedicationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401573d8",
  null
  
)

export default component.exports